const state = {
  categories: [],
  selectedCategory: null,
  selectedFilter: null
};

const mutations = {
  ADD_CATEGORY(state, category) {
    state.categories.push(category);
  },
  SET_SELECTED_CATEGORY(state, categoryId) {
    state.selectedCategory = categoryId;
  },
  SET_SELECTED_FILTER(state, filter) {
    state.selectedFilter = filter;
  }
};

const actions = {

  downloadCategories({ dispatch, commit, rootState }, categories) {
    return new Promise(resolve => {
      const tags = [];
      const brands = [];
      const videos = [];

      const promiseArray = categories.map(element => new Promise(resolve => {
        rootState.Database.db
          .collection("categories")
          .doc(element)
          .get()
          .then(doc => {
            const data = doc.data();
            if (doc.exists && doc.data() !== undefined && doc.data().enabled) {

              // Download tags
              // eslint-disable-next-line
              const tagPromiseArray = data.tags.map(element => {
                if (!tags.some(t => t === element)) {
                  tags.push(element);
                  return dispatch("downloadTag", element);
                }
              });

              // Download brands
              const brandPromise = [];
              if (!brands.some(b => b === data.brand)) {
                brands.push(data.brand);
                brandPromise.push(dispatch("downloadBrand", data.brand));                  
              }

              // Download videos
              // eslint-disable-next-line
              const videoPromiseArray = data.videos.map(element => {
                if (!videos.some(t => t === element)) {
                  return dispatch("downloadVideo", element).then(videoEnabled => {
                    if (videoEnabled) {
                      videos.push(element);
                    } else {
                      data.videos.splice(data.videos.findIndex(el => el === element), 1);
                    }
                  });

                }
              });
              commit("ADD_CATEGORY", {
                id: doc.id,
                name: data.name,
                brand: data.brand,
                description: data.description,
                accent: data.accent,
                tags: data.tags,
                videos: data.videos,
                dateAdded: data.dateAdded,
                enabled: data.enabled
              });

              Promise.all([...tagPromiseArray, ...videoPromiseArray, ...brandPromise]).then(() => {
                resolve();
              });
            }
            resolve();
              
          });
      }));
      
      Promise.all(promiseArray).then(() => {
        resolve();
      });

    });
  },
  changeCategoryFilter({ commit }, data) {
    commit("SET_SELECTED_FILTER", data);
  },
  changeCategory({ commit }, category) {
    commit("SET_SELECTED_CATEGORY", category);
  }
};

const getters = {
  // getCategories({state}) {
  // let b = [];
  // state.categories.forEach(element => {
  //     b.push(element);
  // });
  // return b;
  // }, 
  getCurrentCategory(state) {
    return state.categories.find(category => category.id === state.selectedCategory);
  },
  getFilteredCategories(state) {
    if (state.selectedFilter && state.categories.length > 0) {
      if (state.selectedFilter.type === "TAG") {
        return state.categories.filter(cat => cat.tags.find(tag => tag === state.selectedFilter.id));
      }
      if (state.selectedFilter.type === "BRAND") {
        return state.categories.filter(cat => cat.brand === state.selectedFilter.id);
      }
    }
    
    return null;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}; 



// WEBPACK FOOTER //
// ./src/store/modules/Categories.js